<template>
    <div>
        <v-expansion-panels v-model="expandedPanel">
            <v-expansion-panel class="no-elevation" >
                <v-expansion-panel-header>
                    <div class="zoezi-activity-section">
                        <h3>{{$translate('Receipts')}}</h3>
                        <small>{{$translate("Everything you've bought is listed here")}}</small>
                    </div>
                    <v-badge color="grey" :content="String(receipts.length)"></v-badge>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div v-if="receipts.length == 0">
                        {{$translate('No receipts yet')}}
                    </div>
                    <div class="zoezi-card-default zoezi-card-horizontal" v-for="receipt in receipts" :key="receipt.id">
                        <div class="z-card-image" :style="{'background-image': 'url(' + $api.getAssetUrl('/assets/img/cash.png') + ')' }">
                            <div class="z-card-image-time" style="background-color: rgba(192,160,0,0.7)">{{receipt.amount | price}}</div>
                            <div class="z-card-image-small" style="background-color: rgba(192,160,0,0.7)">{{Date.formatFullShorter(receipt.date)}}</div>
                        </div>
                        <div class="z-card-content">
                            <strong>{{receipt.name}}</strong><br>
                            <div>{{$translate(receipt.date.getWeekDayString())}} {{receipt.date.getDate()}} {{$translate(receipt.date.getMonthName())}} {{receipt.date.getFullYear()}}</div>
                            <div>{{receipt.amount | price}}</div>
                        </div>
                        <div class="z-card-action pt-2 px-2">
                            <v-btn block class="primary my-2 zoezi-button-thin" @click="getPdf(receipt)">{{$translate('Receipt')}}</v-btn>
                        </div>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import {downloadFile, isExpoApp} from '../util.js'
export default {
    name: 'zoezi-receiptlist',

    zoezi: {
        title: 'Receipt list',
        icon: 'mdi-receipt'
    },

    data: () => ({
        receipts: [],
        unsubscribe: null,
        expandedPanel: 0
    }),

    props: {
    },

    methods: {
        fetchReceipts() {
            this.$api.get('/api/memberapi/payments/get').then(x => {
                this.receipts = x.map(r => ({...r, date: Date.newFull(r.date)})).sort((a, b) => b.date - a.date);
            });
        },
        getPdf(receipt) {
            if (isExpoApp() && window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'openReceipt', data: receipt }));
            } else {
                this.$api.get('/api/memberapi/receipt/get', {id: receipt.id}, {blob: true}).then(x => {
                    downloadFile({filename: receipt.name + '.pdf', blob: x, type: 'application/pdf'});
                })
            }
        }
    },

    mounted() {
        this.fetchReceipts();
        this.unsubscribe = this.$root.$api.subscribe({type: 'payment', callback: () => this.fetchReceipts()})
    },
    destroyed() {
        this.unsubscribe?.();
    }
}
</script>
